export default {
    inserted: (el) => {
        const ele = el.tagName === 'INPUT' ? el : el.querySelector('input');
        ele.addEventListener('mousewheel', () => {
            ele.blur();
        });
    }
};
